import { Product } from 'src/models/Product';

export class CondolenceVideo extends Product {
  constructor(params: CondolenceVideo = {} as CondolenceVideo) {
    super(params);
  }
}
